import React, { useState } from 'react'
import ThemeDropDown from '../../components/ThemeDropDown'
import Link from 'next/link'
import { useSelector } from 'react-redux'

export default function ChatFooter() {
  const [hideAll, setHideAll] = useState(true)
  const { activeChatTheme } = useSelector((state) => state.theme)

  const handleHideAll = () => {
    document.body.classList.toggle('hide-all')
    setHideAll(!hideAll)
  }
  return (
    <div
      className={`  flex pt-[13px] absolute bottom-2.5 w-full pl-20 pr-8 ${activeChatTheme === 'theme5' ? '' : 'bg-black'}`}
    >
      <div className="footer-left w-full items-center">
        <ul className="flex gap-x-10 h-full items-center text-sm font-black text-gray-400">
          <li>
            <Link href="/privacy"> Privacy</Link>
          </li>
          <li>
            <Link href="/terms-and-conditions">Terms</Link>
          </li>
        </ul>
      </div>
      <div className="footer-right w-full">
        <ul
          className={`flex items-center justify-end gap-x-9 text-sm ${activeChatTheme === 'theme5' ? 'text-slate-950' : 'text-white'} font-black text-black`}
        >
          <li>
            <ThemeDropDown hasText />
          </li>
          {/* <li>Improvements</li> */}
          <li
            className="cursor-pointer"
            onClick={() => {
              handleHideAll()
            }}
          >
            {!hideAll ? 'Show All' : 'Hide All'}
          </li>
        </ul>
      </div>
    </div>
  )
}
